import './App.css';
import Temperature from './components/Temperature';
import Details from './components/Details';
import getFormattedData from './makeitwork/weather';
import Searchbar from './components/Searchbar';
import { useState, useEffect } from 'react';
import Daily from './components/Daily';
import { Icon } from '@iconify/react';

function App() {
  const [weatherData, setWeatherData] = useState(null);
  const [temperatureUnit, setTemperatureUnit] = useState('Celsius');
  const [loading, setLoading] = useState(true); 
  const [lastCity, setLastCity] = useState("");
  const [showError, setShowError] = useState(false);
  const [fadeOpacity, setFadeOpacity] = useState(0);



  useEffect(() => {
    const storedLastCity = localStorage.getItem('lastCity');
    if (storedLastCity) {
      setLastCity(storedLastCity);
    }
  }, []);

  const fetchWeather = async (city) => {
    try {
      const data = await getFormattedData({ q: city});
      if (data.data.error ){
        setShowError(true);
      } 
      else {
        setWeatherData(data.data);
        setLastCity(city);
        setShowError(false);
      }

      localStorage.setItem('lastCity', city);
    } catch (error) {
      console.error('Error fetching weather data:', error);
    }finally {
        setTimeout(() => {
        setLoading(false);
        }, 4000);
      }

    
  };

  const handleCitySelection = (selectedCity) => {
    fetchWeather(selectedCity);
};;

const handleToggleTemperatureUnit = (unit) => {
  setTemperatureUnit(unit);
};


useEffect(() => {
  const fetchDefaultWeather = async () => {
    const storedLastCity = localStorage.getItem('lastCity');
    try {
      if (navigator.geolocation && (storedLastCity === "" || storedLastCity === "null" || storedLastCity == null)) {
        navigator.geolocation.getCurrentPosition(
          async (position) => {
            const latitude = position.coords.latitude;
            const longitude = position.coords.longitude;
            const reverseGeocodeUrl = `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`;
            const reverseGeocodeResponse = await fetch(reverseGeocodeUrl);
            const reverseGeocodeData = await reverseGeocodeResponse.json();
            const defaultCity = reverseGeocodeData.city;
            fetchWeather(defaultCity);
            localStorage.setItem('lastCity', defaultCity );
          },
          (error) => {
            fetchWeather(storedLastCity);
          }
        );
      } else {
        fetchWeather(storedLastCity);
      }
    } catch (error) {
      setLoading(false);
    } 
  };
  fetchDefaultWeather();
}, []);



useEffect(() => {
  const targetOpacity = showError ? 1 : 0;
  let startTimestamp;
  let animationFrameId;

  const updateOpacity = (timestamp) => {
    if (!startTimestamp) {
      startTimestamp = timestamp;
    }

    const progress = timestamp - startTimestamp;
    const duration = 500; 

    if (progress < duration) {
      setFadeOpacity((progress / duration) * targetOpacity);
      animationFrameId = requestAnimationFrame(updateOpacity);
    } else {
      setFadeOpacity(targetOpacity);
    }
  };

  animationFrameId = requestAnimationFrame(updateOpacity);

  return () => cancelAnimationFrame(animationFrameId);
}, [showError]);

  return (
    
    <div >

    {loading ? (
        // Loading screen while weather data is being fetched
        <div className="flex items-center justify-center h-screen">
          <svg xmlns="http://www.w3.org/2000/svg" width="10rem" height="10rem" viewBox="0 0 24 24" ><path fill="white" d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,20a9,9,0,1,1,9-9A9,9,0,0,1,12,21Z" transform="matrix(0 0 0 0 12 12)"><animateTransform id="svgSpinnersPulseRingsMultiple0" attributeName="transform" begin="0;svgSpinnersPulseRingsMultiple2.end" calcMode="spline" dur="1.2s" keySplines=".52,.6,.25,.99" type="translate" values="12 12;0 0"></animateTransform><animateTransform additive="sum" attributeName="transform" begin="0;svgSpinnersPulseRingsMultiple2.end" calcMode="spline" dur="1.2s" keySplines=".52,.6,.25,.99" type="scale" values="0;1"></animateTransform><animate attributeName="opacity" begin="0;svgSpinnersPulseRingsMultiple2.end" calcMode="spline" dur="1.2s" keySplines=".52,.6,.25,.99" values="1;0"></animate></path><path fill="white" d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,20a9,9,0,1,1,9-9A9,9,0,0,1,12,21Z" transform="matrix(0 0 0 0 12 12)"><animateTransform id="svgSpinnersPulseRingsMultiple1" attributeName="transform" begin="svgSpinnersPulseRingsMultiple0.begin+0.2s" calcMode="spline" dur="1.2s" keySplines=".52,.6,.25,.99" type="translate" values="12 12;0 0"></animateTransform><animateTransform additive="sum" attributeName="transform" begin="svgSpinnersPulseRingsMultiple0.begin+0.2s" calcMode="spline" dur="1.2s" keySplines=".52,.6,.25,.99" type="scale" values="0;1"></animateTransform><animate attributeName="opacity" begin="svgSpinnersPulseRingsMultiple0.begin+0.2s" calcMode="spline" dur="1.2s" keySplines=".52,.6,.25,.99" values="1;0"></animate></path><path fill="white" d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,20a9,9,0,1,1,9-9A9,9,0,0,1,12,21Z" transform="matrix(0 0 0 0 12 12)"><animateTransform id="svgSpinnersPulseRingsMultiple2" attributeName="transform" begin="svgSpinnersPulseRingsMultiple0.begin+0.4s" calcMode="spline" dur="1.2s" keySplines=".52,.6,.25,.99" type="translate" values="12 12;0 0"></animateTransform><animateTransform additive="sum" attributeName="transform" begin="svgSpinnersPulseRingsMultiple0.begin+0.4s" calcMode="spline" dur="1.2s" keySplines=".52,.6,.25,.99" type="scale" values="0;1"></animateTransform><animate attributeName="opacity" begin="svgSpinnersPulseRingsMultiple0.begin+0.4s" calcMode="spline" dur="1.2s" keySplines=".52,.6,.25,.99" values="1;0"></animate></path></svg>           </div>
      ) : (
        <>
        {showError ? (
          // Display error message and icon
          <div style={{ opacity: fadeOpacity }}>
          <div className="flex flex-col items-center justify-center h-screen">
            <Icon icon="tabler:error-404" width="7rem" height="7rem" style={{ color: 'white' }} />
            <p className='text-4xl text-white'>No available data</p>
            
            <div className="close-container" onClick={() => setShowError(false)} >
                <div className="leftright"></div>
                <div className="rightleft"></div>
                <label className="close">close</label>
            </div>
          </div>
          </div>

        ) : (
          
        <>
                <Searchbar 
            onCitySelect={handleCitySelection}
            onToggleTemperatureUnit={handleToggleTemperatureUnit} />
            {weatherData && (
                      <>
                          <Temperature 
                            currentFormattedData={weatherData} 
                            temperatureUnit={temperatureUnit}
                          />
                          <Details
                            h="hourly forecast" 
                            currentFormattedData={weatherData} 
                            temperatureUnit={temperatureUnit}
                            />
                          <Daily 
                            h="daily forecast" 
                            currentFormattedData={weatherData} 
                            temperatureUnit={temperatureUnit}
                            />
                                          </>
            )}
                      </>
        )}
      </>
    )}
  </div>
);
}

export default App;

